function Footer(){
    return (
        <div className="ui segment" style={{fontSize: '10px'}}>
        Copyright ©  | 2021  |  LIMBISM
      </div>
    )
}

export default Footer;